import { generateTestId } from "@client-shared";

export const setManualAddProductModalTestId = (identifier: string): string =>
  generateTestId("ManualAddProductModal", identifier);
